<template>
    <!-- <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button class="button_back" data-testid="directions-18" @click="goBack">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>Search Filter</ion-title>
        <ion-buttons slot="end">
            <ion-button @click="reset">
                <span>Reset</span>
            </ion-button>
        </ion-buttons>
    </ion-toolbar> -->

    <!-- <div class="main_wrapper ion-padding"> -->
        <!-- <div class="search-bar"><el-input v-model="selectedValues.text" data-testid="directions-19" class="job-board__search"
                placeholder="Search" clearable @clear="clearText">
                <template #prefix>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z"
                            stroke="#484848" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M22 22L20 20" stroke="#484848" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </template>
            </el-input>
            <button class="filter-button">
                <img src="@/assets/img/job-seeker/setting-active.svg" />
            </button>
        </div> -->
        
        <div class="main_wrapper ion-padding">
            <el-button class="reset-button" @click="reset">Reset</el-button>
            <div v-if="loading">
                <JobListingFilterSkeleton :skeletonCount="1" />
            </div>
            <div v-else>
                <div v-if="isFilterOptionsVisible" class="filter-options">
                    <div class="filter-type">
                        <h3 class="filter-title">Filter by Job Type</h3>
                        <div class="filter-item">
                            <div class="filter-select" v-for="(type, index) in jobTypes" :key="index">
                                <input data-testid="directions-20" type="radio" name="type" :id="'jobType-' + index"
                                    v-model="selectedValues.jobType" :value="type.title">
                                <label :for="'jobType-' + index">{{ type.title }}</label>
                            </div>
                        </div>
                    </div>
                    <div class="filter-type">
                    <h3 class="filter-title">Filter by Role</h3>
                    <div class="filter-item">
                        <div class="filter-select" v-for="(platformRole, index) in platformRoles" :key="index">
                            <input data-testid="directions-78-1" type="radio" name="platform_role" :id="'platformRole-' + index"
                                v-model="selectedValues.platformRole" :value="platformRole.slug">
                            <label :for="'platformRole-' + index">{{ platformRole.name }}</label>
                        </div>
                    </div>
                </div>
                    <div class="filter-type">
                        <h3 class="filter-title">Filter by Job Location</h3>
                        <!-- <div class="filter-item el-input" v-if="isAustralia">
                             <div class="filter-select" v-for="(location, index) in jobLocations" :key="index">
                                <input data-testid="directions-21" type="radio" name="location" :id="'location-' + index"
                                    v-model="selectedValues.jobLocation" :value="location.alphaCode">
                                <label :for="'location-' + index">{{ location.name }}</label>
                            </div>
                        </div> -->
                        <div class="filter-item el-input">
                            <vue-google-suburb-autocomplete 
                            data-testid="directions-102" 
                            id="map" 
                            classname="el-input__inner"
                            v-model="selectedValues.jobLocation"
                            placeholder="Job Location" 
                            v-on:placechanged="updateAddressData"
                            @keyup="setAddress"
                            :initial-location="selectedValues.jobLocation"
                            :country="countryArray"
                            :key="addressComponent"
                        />
                        </div>
                    </div>
                    <!-- <el-radio-group v-model="rateType" size="large">
                        <h3 class="filter-title">Filter by </h3>
                        <el-radio size="large" label="hourly">Hourly Rate</el-radio>
                        <el-radio size="large" label="annual">Annual Salary</el-radio>
                    </el-radio-group>
                    <RangeSlider :min="sliderConfig.min" :max="sliderConfig.max" :initialValue="sliderConfig.initialValue"
                        @change="handleSliderChange" /> -->
                    <div class="filter-type">
                        <h3 class="filter-title">Tagged Skills</h3>
                        <div class="filter-item">
                            <div class="filter-select" v-for="(skill, index) in taggedSkills" :key="index">
                                <input data-testid="directions-22" type="checkbox" name="tagged-skills"
                                    :id="'skill-' + index" v-model="selectedValues.taggedSkills" :value="skill.name">
                                <label :for="'skill-' + index">{{ skill.name }}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <el-form-item class="button_submit mb0">
                    <el-button class="submit" type="blue" data-testid="directions-23" @click="goSearch">
                        Apply
                    </el-button>
                </el-form-item>
            </div>
        </div>
    <!-- </div> -->


</template>

<script setup>
import { ref, onMounted, computed, defineEmits } from 'vue';
import { useRouter } from "vue-router";
import { useStore } from "vuex";
// import RangeSlider from "@/components/RangeSlider/RangeSlider.vue";
import JobListingFilterSkeleton from "@/components/JobListingSkeleton/JobListingFilterSkeleton.vue";
import { VueGoogleSuburbAutocomplete } from "@/components/components";
import { isAustraliaRegion } from '@/helpers/region/regionHelper.js';

const $store = useStore();
const $router = useRouter();
const isFilterOptionsVisible = ref(true);
const currentRouteName = ref(null);
// const sliderValue = ref(null);
// const rateType = ref("");
const isAustralia = isAustraliaRegion();

const selectedValues = ref({
    text: '',
    jobType: '',
    jobLocation: '',
    platformRole: '',
    taggedSkills: [],
    // rate: {
    //     type: '', // Default value for rateType
    //     value: 0 // Default value for sliderValue
    // }
});

const addressComponent = ref(0);

const jobTypes = ref([]);
const platformRoles = ref([]);
const taggedSkills = ref([]);
const jobLocations = ref([]);
const loading = ref(false);
// Function to reset filters
const emit = defineEmits(['update:modalCreateVisible']);
const reset = () => {
    localStorage.removeItem('jobPosterJobsFilterObject');
    // 
    selectedValues.value = {
        text: '',
        jobType: '',
        jobLocation: '',
        platformRole: '',
        taggedSkills: [],
        // rate: {
        //     type: '',
        //     value: 0
        // }
    };
    // rateType.value = "";
    addressComponent.value += 1;
    // sliderValue.value = 0;
}

const countryArray = computed(() => {
    const region = process.env.VUE_APP_REGION;
    if (region === 'US') return ['us'];
    if (region === 'AU') return ['au'];
    return []; // Default or empty if region is not recognized
});


// Function to navigate back
// const goBack = () => {
//     currentRouteName.value = $router.currentRoute.value.name;
//     console.log("🚀 ~ setup ~ currentRouteName.value:", currentRouteName.value)
//     $store.dispatch('PREVIOUS_ROUTE_NAME', currentRouteName.value);

//     $router.push({
//         name: "job_poster",
//     });
// };

// Function to perform search
const goSearch = () => {
    // Save selected values to local storage
    localStorage.setItem('jobPosterJobsFilterObject', JSON.stringify(selectedValues.value));
    // Perform search action
    currentRouteName.value = $router.currentRoute.value.name;
    $store.dispatch('PREVIOUS_ROUTE_NAME', currentRouteName.value);
    // $router.push({
    //     name: "job_poster",
    // });
    emit('update:modalCreateVisible', false);
    emit("job-listing-filter");
};


// const clearText = () => {
//     console.log('clear text')
//     selectedValues.value.text = '';
//     // Update local storage to remove only the 'text' property from 'jobPosterJobsFilterObject'
//     const storedValues = JSON.parse(localStorage.getItem('jobPosterJobsFilterObject'));
//     if (storedValues) {
//         delete storedValues.text;
//         localStorage.setItem('jobPosterJobsFilterObject', JSON.stringify(storedValues));
//     }
// };

const updateAddressData = (addressData) => {
    selectedValues.jobLocation = '';
    selectedValues.value.jobLocation = addressData.formatted_address;
};

const setAddress = () => {
    selectedValues.value.jobLocation = '';
};

// Restore selected values from local storage on component mount
onMounted(() => {

    const storedValues = localStorage.getItem('jobPosterJobsFilterObject');
    if (storedValues) {
        const parsedValues = JSON.parse(storedValues);
        selectedValues.value = parsedValues;

        // rateType.value = parsedValues.rate.type;

        // // Set the sliderValue to the stored value
        // sliderValue.value = parseFloat(parsedValues.rate.value);
    }
    jobListingAttributesForFilter()

});

// function handleSliderChange(event) {
//     if (rateType.value === "") {
//         rateType.value = "hourly";
//     }
//     const numericValue = parseFloat(event.target.value);
//     sliderValue.value = event.target.value; // Updating parent value with the value emitted from child
//     selectedValues.value.rate.value = numericValue;
// }

// Watch for changes in rateType
// watch(rateType, (newValue) => {
//     selectedValues.value.rate.type = newValue; // Update selectedValues object
//     if(newValue === 'hourly' && selectedValues.value.rate.value > 200 || newValue === 'annual' && selectedValues.value.rate.value < 200) {
//         sliderValue.value = 200;
//         selectedValues.value.rate.value = 200;
//     }
// });


// Computed property to determine slider configuration based on rateType
// const sliderConfig = computed(() => {
//     if (rateType.value === 'hourly') {
//         return {
//             min: 0,
//             max: 200,
//             initialValue: sliderValue.value ? sliderValue.value : 0
//         };
//     } else if (rateType.value === 'annual') {
//         return {
//             min: 200,
//             max: 200000,
//             initialValue: sliderValue.value ? sliderValue.value : 20000
//         };
//     } else {
//         // Default values in case rateType is not set
//         return {
//             min: 0,
//             max: 200,
//             initialValue: sliderValue.value ? sliderValue.value : 0
//         };
//     }
// });

const jobListingAttributesForFilter = () => {
    loading.value = true;
    (async () => {

        const response = await $store.dispatch("GET_JOB_POSTER_LISTINGS");
        loading.value = false;
        jobTypes.value = response.data.type;
        platformRoles.value = response.data.platformRoles;
        if(isAustralia) {
            jobLocations.value = response.data.location;
        }
        taggedSkills.value = response.data.popularSkills;

    })();
}

</script>
